function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "11",
  viewBox: "0 0 14 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11.58 9.5h0l1.211-4.377a.843.843 0 00-1.154-.996L9.38 5.13 7.738 2.154a.843.843 0 00-1.476 0l.656.363-.656-.363L4.62 5.13 2.363 4.127l-.304.686.304-.686a.843.843 0 00-1.154.996L2.42 9.5a.843.843 0 00.813.619h7.534c.38 0 .712-.253.813-.619z",
  stroke: "#F78BCC",
  strokeWidth: "1.5"
})));